import About from "./About";
import Features from "./Features";
import Jobs from "./Jobs";
import Solutions from "./Solutions";
import Pricing from "./Pricing";
import Contact from "./Contact";
import Livechat from "./Livechat";
import Helpdesk from "./Helpdesk";
import Travelalerts from "./Travelalerts";
import Travelguides from "./Travelguides";
import Tips from "./Tips";
import Apidevelopers from "./Apidevelopers";
import Faq from "./Faq";
import Newsletter from "./Newsletter";
import Privacypolicy from "./Privacypolicy";
import TermAndCondition from "./TermsAndCondition";
import JoinUs from "./JoinUs";
function HomeRoute(props) { 
   const composite = {
      about: <About />, 
      features: <Features/>, 
      jobs: <Jobs/>, 
      solutions: <Solutions/>, 
      pricing: <Pricing/>, 
      contact: <Contact/>, 
      livechat: <Livechat/>, 
      helpdesk: <Helpdesk/>, 
      travelalerts: <Travelalerts/>, 
      travel_guides: <Travelguides/>, 
      tips: <Tips/>, 
      apidevelopers: <Apidevelopers/>, 
      faq: <Faq/>, 
      newsletter: <Newsletter/>, 
      privacypolicy: <Privacypolicy/>, 
      terms_and_conditions: <TermAndCondition/>, 
      join_us: <JoinUs/> 
  }; 
 return <>{composite[props.component]}</>;
}
export default HomeRoute;




